import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import posed, { PoseGroup } from "react-pose";
import classes from "./NavCard.module.css";
import Articles from "./Articles/Articles";
import Projects from "./Projects/Projects";
import Skills from "./Skills/Skills";
import OpenSource from "./OpenSource/OpenSource";
import ContentList from "./ContentList/ContentList";

class NavCard extends React.Component {
  render() {
    const RouteContainer = posed.div({
      enter: { opacity: 1, delay: 100, beforeChildren: true },
      exit: { opacity: 0 }
    });

    const {location} = this.props;

    return (
      <div className={classes.NavContent}>
        <div className={classes.Card}>
          <PoseGroup>
            <RouteContainer key={location.pathname}>
            <Switch location={location}>
              <Route
                path="/portfolio/articles"
                component={Articles}
              />
              <Route
                path="/portfolio/projects"
                render={Projects}
              />
              <Route
                path="/portfolio/opensource"
                component={OpenSource}
              />
              <Route
                path="/portfolio/skills"
                component={Skills}
              />
              <Route
                exact
                path="/portfolio"
                component={ContentList}
              />
              <Route
                exact
                path="/"
                component={ContentList}
              />
            </Switch>
            </RouteContainer>
          </PoseGroup>
        </div>
      </div>
    );
  }
}

export default withRouter(NavCard);
